import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Link } from "wouter";

const DISMISSED_KEY = "rheumhub_storage_notice_dismissed";

export function LocalStorageNotice() {
  const [visible, setVisible] = useState(false);
  const isAdvicelineHub = typeof window !== "undefined" && window.location.hostname.includes("advicelinehub");
  const appName = isAdvicelineHub ? "Advice Line Hub" : "RheumHub";

  useEffect(() => {
    try {
      if (!localStorage.getItem(DISMISSED_KEY)) {
        setVisible(true);
      }
    } catch {
      // localStorage unavailable — don't show
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISSED_KEY, "1");
    } catch {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Browser storage notice"
      className="fixed bottom-0 inset-x-0 z-50 bg-slate-800 text-slate-100 text-sm px-4 py-3 shadow-xl"
    >
      <div className="max-w-5xl mx-auto flex items-start justify-between gap-4">
        <p className="leading-snug">
          <strong className="font-semibold text-white">{appName} uses your browser's local storage</strong>
          {" "}for essential functional purposes only — to remember your role{!isAdvicelineHub ? ", AI consent, clinical safety acknowledgement, and practice-level preference" : " and preferences"}.
          No advertising data is stored. We use self-hosted, cookieless analytics (Umami) to count page views — no personal data is collected. See our{" "}
          <Link href="/privacy" className="underline text-teal-300 hover:text-teal-200 whitespace-nowrap">
            Privacy Policy
          </Link>
          {" "}for details.
        </p>
        <button
          onClick={dismiss}
          aria-label="Dismiss browser storage notice"
          className="shrink-0 mt-0.5 p-1 rounded hover:bg-white/10 transition-colors"
        >
          <X className="h-4 w-4 text-slate-300" />
        </button>
      </div>
    </div>
  );
}
